import React from 'react';

// Constants
import {
  CompanyName,
  CompanyTagLine,
  FULL_BUSINESS_URL,
  KeywordsPages,
} from '../../utils/constants/Constants';
import { INDEX_PAGE_URL } from '../../utils/constants/Routes';

// Data
import {
  homePageAdditionalMeta,
  homePageStructuredData,
  websiteStructuredData,
} from '../../utils/data/MetaData';

// Components
import Navbar from '../../components/nav/Navbar';
import IndexPageMainContainer from '../../components/index/IndexPageMainContainer';
import { HelmetItem } from '../../components/utils/HelmetItem';

// Utils
import { buildBreadcrumbLd } from '../../utils/seo/breadcrumbs';
import FAQSchema from '../../utils/seo/FAQSchema';
import { homePageFaqItems } from '../../utils/data/faqSchemas';

const IndexPage = React.memo(() => {
  const breadcrumbLd = buildBreadcrumbLd({
    baseUrl: FULL_BUSINESS_URL,
    items: [{ label: 'Home', href: INDEX_PAGE_URL }],
  });

  return (
    <>
      {/* Tab Data */}
      <HelmetItem
        PageName='Queen Blaire'
        desc={`Serve ${CompanyName}, your Favorite Muscle Goddess and Elite Dominatrix. Explore sessions, tributes, premium links, and exclusive content for devoted submissives.`}
        keywords={KeywordsPages}
        additionalMeta={homePageAdditionalMeta}
        structuredData={[homePageStructuredData, websiteStructuredData, breadcrumbLd]}
        canonicalPath={INDEX_PAGE_URL}
      />

      {/* Page */}
      <div className='grid min-h-screen w-full overflow-hidden font-poppins bg-colour2 dark:bg-colour2 text-colour1 dark:text-colour1'>
        <div className='grid min-h-screen'>
          {/* Navigation */}
          <Navbar />

          {/* Header */}
          <header className='pt-24 px-6 lg:container lg:mx-auto lg:px-24'>
            <h1
              aria-label={`Homepage of ${CompanyName}`}
              className='text-center font-titleFont text-6xl lg:text-6xl tracking-widest'
            >
              {CompanyName}
            </h1>

            <div className='mx-auto grid justify-center'>
              <h2 className='text-xl xs:text-2xl mt-1 sm:text-3xl md:text-4xl lg:text-4xl lg:py-2 text-center'>
                {CompanyTagLine}
              </h2>
            </div>
          </header>

          {/* Main page content */}
          <IndexPageMainContainer />
        </div>

        {/* FAQ JSON-LD */}
        <FAQSchema items={homePageFaqItems} />
      </div>
    </>
  );
});

export default IndexPage;
